export default "__VITE_ASSET__BPtrPlpE__"